export default __webpack_public_path__ + "static/face_1-b9d791ba1968c80d8659562052e5073f.jpg";